import { Accordion } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const AccordionContent = ({
  className,
  children,
  ...props
}: ComponentProps<typeof Accordion.Content>) => (
  <Accordion.Content
    data-slot="accordion-content"
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("pt-0 pb-4", className)}>{children}</div>
  </Accordion.Content>
);
